import { useEffect, useState } from 'react'
import { fetchUserMetrics } from '../services/api'
import type { UserMetricsData } from '../types'

export default function UserMetrics() {
  const [data, setData] = useState<UserMetricsData[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchUserMetrics()
      .then(setData)
      .finally(() => setLoading(false))
  }, [])

  return (
    <div>
      <h2 className="text-3xl font-bold text-white mb-8">User Metrics</h2>
      
      {loading ? (
        <div className="text-gray-400">Loading...</div>
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
            <div className="bg-gray-800 rounded-lg p-6 border border-gray-700">
              <h3 className="text-sm font-medium text-gray-400 mb-2">Total Users</h3>
              <p className="text-3xl font-bold text-white">
                {data.reduce((sum, d) => sum + d.totalUsers, 0).toLocaleString()}
              </p>
            </div>
            <div className="bg-gray-800 rounded-lg p-6 border border-gray-700">
              <h3 className="text-sm font-medium text-gray-400 mb-2">New Users</h3>
              <p className="text-3xl font-bold text-white">
                {data.reduce((sum, d) => sum + d.newUsers, 0).toLocaleString()}
              </p>
            </div>
            <div className="bg-gray-800 rounded-lg p-6 border border-gray-700">
              <h3 className="text-sm font-medium text-gray-400 mb-2">Retention Rate</h3>
              <p className="text-3xl font-bold text-white">
                {(data.reduce((sum, d) => sum + d.retentionRate, 0) / data.length || 0).toFixed(1)}%
              </p>
            </div>
            <div className="bg-gray-800 rounded-lg p-6 border border-gray-700">
              <h3 className="text-sm font-medium text-gray-400 mb-2">Avg Session Duration</h3>
              <p className="text-3xl font-bold text-white">
                {Math.round(data.reduce((sum, d) => sum + d.avgSessionDuration, 0) / data.length || 0)}m
              </p>
            </div>
          </div>

          <div className="bg-gray-800 rounded-lg border border-gray-700 overflow-hidden">
            <table className="min-w-full divide-y divide-gray-700">
              <thead className="bg-gray-700">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">Date</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">Total Users</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">New Users</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">Active Users</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">Retention Rate</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">Avg Session</th>
                </tr>
              </thead>
              <tbody className="bg-gray-800 divide-y divide-gray-700">
                {data.map((row, idx) => (
                  <tr key={idx}>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-300">{row.date}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-white">{row.totalUsers.toLocaleString()}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-300">{row.newUsers.toLocaleString()}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-300">{row.activeUsers.toLocaleString()}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-white">{row.retentionRate.toFixed(1)}%</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-300">{row.avgSessionDuration}m</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  )
}
